/**
 * 统一的 API/上传 URL 组装工具
 *
 * 目标：
 * - 支持基础路径为相对路径（如 /api）或绝对 URL（如 https://api.example.com/api）
 * - 正确处理多余的斜杠，避免出现 //upload 或 /apiapi 等问题
 */

import { API_BASE_URL, UPLOAD_API_BASE_URL } from '../config/api';

/**
 * 安全拼接 base 和 path
 * - 移除 base 末尾多余的 /
 * - 移除 path 开头多余的 /
 * - 中间强制加一个 /
 */
const joinUrl = (base: string, path: string): string => {
  const trimmedBase = base.replace(/\/+$/, '');
  const trimmedPath = path.replace(/^\/+/, '');

  if (!trimmedBase) {
    return `/${trimmedPath}`;
  }

  return `${trimmedBase}/${trimmedPath}`;
};

/**
 * 解析通用 API URL
 * @param path 相对路径，如 "/upload" 或 "upload"
 */
export const resolveApiUrl = (path: string): string => {
  return joinUrl(API_BASE_URL, path);
};

/**
 * 解析上传专用 URL
 * - 优先使用 UPLOAD_API_BASE_URL
 * - 如果未配置，则回退到 API_BASE_URL
 *
 * @param path 相对路径，如 "/upload" 或 "upload"
 */
export const resolveUploadUrl = (path: string): string => {
  const base = UPLOAD_API_BASE_URL || API_BASE_URL;
  return joinUrl(base, path);
};


